var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Copiar'),expression:"'Copiar'"}],staticClass:"d-inline items-center mt-5",attrs:{"color":"primary","type":"flat","icon-pack":"feather","icon":"icon-copy"},on:{"click":function($event){return _vm.copyToClipboard()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }